module.exports = __webpack_public_path__ + "media/KikiGOT.742197a6.mp3";